import { Component, OnInit, Input, ViewChild, EventEmitter, Output, AfterViewInit, Renderer2, ElementRef, OnChanges } from '@angular/core';
import { Table } from 'primeng/table';
import * as moment_timezone from 'moment-timezone'
import * as moment from 'moment';
import { Subject } from 'rxjs';
import { utility } from 'src/app/models/constants';
import { SharedService } from 'src/app/services/shared/shared.service';
import { StorageService } from 'src/app/services/storage.service';

const momentTz = moment_timezone;
const dateReportFormat = "YYYYMMDDhhmmss";


@Component({
    selector: 'app-inward-table',
    standalone: false,
    templateUrl: './inward.component.html',
    styleUrls: ['./inward.component.scss'],
})
export class InwardTableComponent implements OnInit, AfterViewInit, OnChanges {

    selectedXmlRows: any;
    @Input() selectedCountry: string;
    @Input() headers: any = [];
    @Input() data: any = [];
    @Input() filters: any = [];
    @Input() path: string;
    @Input() reqOrInv: boolean = true;//req = false, inv=true
    @Input() isManual: boolean;
    @Input() isAuto: boolean;
    @Input() isHistory: boolean = false;

    @ViewChild('inwDt') inwDt: Table | undefined;

    @Input() clearTable: Subject<boolean>;
    @Output() selected = new EventEmitter<any>();
    @Output() addNewMessage = new EventEmitter();
    @Output() selectCheckbox = new EventEmitter();
    @Output() hideorShowInwardCompDetail = new EventEmitter();
    utilityInstance = new utility();
    showDetail = false;
    selectedInput: any;
    public selectedCheckBoxData = [];
    downloadButtonEnableManual: boolean = false;
    downloadButtonEnableAuto: boolean = false;
    enableManual: boolean = false;
    enableAuto: boolean = false;
    constructor(private renderer: Renderer2, private elementRef: ElementRef, private sharedService: SharedService,     private storageService: StorageService,){}
    
    ngOnInit() {
        this.clearTable.subscribe(v => {
            this.clear(this.inwDt);
        });
        this.sharedService.roleChangeObserve().subscribe(value => {
            const getRoleData = this.storageService.getLocalCache("selectedRole");
            if (getRoleData && getRoleData !== null && getRoleData !== undefined) {
                const permissionData = JSON.parse(getRoleData);
                this.fetchRoleAccess(permissionData.permissions[0]);
            }

        });
        const getRoleData = this.storageService.getLocalCache("selectedRole");
        if (getRoleData && getRoleData !== null && getRoleData !== undefined) {
            const permissionData = JSON.parse(getRoleData);
            this.fetchRoleAccess(permissionData.permissions[0]);
        }
    }

    fetchRoleAccess(permissionData){
        const colGroupKey = permissionData.screen.find(screen => screen.code === 'SCREEN0005'); 
        if (this.selectedCountry === 'PL') {
          const featureArray = colGroupKey.feature;  
          this.downloadButtonEnableManual = true;
          this.downloadButtonEnableAuto = true;
          if(featureArray!== undefined){
              featureArray.forEach(feature => {                    
                  if(feature.id === 'ACTN000017' && feature.access === true){
                    this.downloadButtonEnableManual = false;
                  }
                  if(feature.id === 'ACTN000019' && feature.access === true){
                    this.downloadButtonEnableAuto = false;
                  }      
              });
          }
        }
        else {
            this.downloadButtonEnableManual = false;
            this.downloadButtonEnableAuto = false;
        }
      }

    ngOnChanges(): void{
        this.selectedCheckBoxData = [];
        this.selectedXmlRows = [];
        this.enableManual = this.isManual;
        this.enableAuto = this.isAuto;
    }
    ngAfterViewInit() {
        this.utilityInstance.setFilterIconAttributes(this.renderer, this.elementRef);
        this.utilityInstance.setPaginatorAttributes(this.renderer,this.elementRef);
    }

    clear(table: Table) {
        table.clear();
    }

    hideOrShowInwardDetail(value: any) {
        this.hideorShowInwardCompDetail.emit(value);
    }

    updateOutput() {
        this.selected.emit(this.selectedXmlRows);
    }


    public onClickAddResponce(rowData:any): void{
        const invoiceData = {
            invoiceRowSel: rowData,
            addNewMsg : true
        }
        this.addNewMessage.emit(invoiceData);
    }

    public getSelectedAll(event: Event & { target: HTMLFormElement}): void{
        // this.selectedCheckBoxData = event.target.ariaChecked ? this.data.map(res =>({...res , isChecked: true})) : [];
        this.selectCheckbox.emit(this.selectedXmlRows);
    }

    public getSelectedRowData(rowData: any, event: Event & { target: HTMLFormElement}): void{
        // rowData['isChecked']= rowData['isChecked']?false: true;
        // this.selectedCheckBoxData = rowData?.isChecked? [...this.selectedCheckBoxData, ...[rowData]]: (this.selectedCheckBoxData.filter(el => el.ackNo !== rowData.ackNo));
        this.selectCheckbox.emit(this.selectedXmlRows);
    }

}